import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import queryString from 'query-string';
import JoinForm from './JoinForm';

const styles = (theme) => ({
  root: {
    overflowX: 'hidden',
    overflowY: 'hidden',
    width: '100%',
  },
});

class Join extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.setState({ lang: queryString.parse(this.props.location.search)['lang'] });
  }

  componentWillUnmount() {}

  render() {
    const { lang } = this.state;

    return (
      <div>
        <CssBaseline />
        {/* <Topbar MIdx={6} SIdx={6} /> */}
        <Topbar MIdx={6} SIdx={3} />
        <JoinForm lang={lang} type={'JOIN'} />
        <Footer />
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Join));
